export const config = {
  rowSelection: false,
  columns: [
    {
      title: 'ID',
      dataIndex: 'id',
      width: 200,
      ellipsis: true,
    },
    {
      title: '适用门店',
      dataIndex: 'shopNames',
      width: 200,
      ellipsis: true,
    },
    {
      title: '适用报价类型',
      dataIndex: 'budgetTypeNames',
      width: 200,
    },
    {
      title: '适用需求标签',
      dataIndex: 'bizTagNames',
      width: 160,
    },
    {
      title: '是否启用',
      dataIndex: 'enabled',
      width: 90,
      render: 'switchRender',
    },
    {
      title: '创建人',
      width: 200,
      dataIndex: 'createdByName',
    },
    {
      title: '创建时间',
      width: 180,
      dataIndex: 'createdTime',
      itemType: 'dateTime',
    },
    {
      title: '最近编辑时间',
      width: 180,
      dataIndex: 'lastUpdatedTime',
      itemType: 'dateTime',
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 120,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'shopIds',
      label: '门店',
      itemType: 'select',
      data: 'companyList',
      mode: 'multiple',
      key: 'id',
      labelKey: 'name',
    },
    {
      name: 'budgetTypes',
      label: '报价类型',
      data: 'budgetList',
      itemType: 'select',
      labelKey: 'name',
      key: 'code',
      mode: 'multiple',
    },
    {
      name: 'bizTags',
      label: '需求标签',
      itemType: 'select',
      data: 'demandList',
      key: 'key',
      labelKey: 'description',
      mode: 'multiple',
    },
  ],
  footer: [
    {
      label: '新增',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
  batchActions: [],
}
